import BellIcon from "../../../assets/images/icons/button-bell.svg";
import BookIcon from "../../../assets/images/icons/button-book.svg";
import ProjectorIcon from "../../../assets/images/icons/button-projector.svg";
import LeaderboardsIcon from "../../../assets/images/icons/LeaderRibbon.svg";
import HelpIcon from "../../../assets/images/icons/button-help.svg";
import SettingsIcon from "../../../assets/images/icons/button-settings.svg";
import HomeworkIcon from "../../../assets/images/icons/button-homework.svg";
import BeamIcon from "../../../assets/images/icons/button-beam.svg";
import PuzzleLabIcon from "../../../assets/images/icons/puzzle-piece-yellow.svg";
import HamburgerIcon from "../../../assets/images/icons/hamburger-old.svg";
import LogoutIcon from "../../../assets/images/icons/button-logout.svg";
import BugIcon from "../../../assets/images/icons/button-bug.svg";
import IndexIcon from "../../../assets/images/icons/button-index.svg";

export const ICON_MAP = {
	BELL: "bell",
	BOOK: "book",
	PROJECTOR: "projector",
	LEADERBOARDS: "leaderboards",
	HELP: "help",
	SETTINGS: "settings",
	HOMEWORK: "homework",
	BEAM: "beam",
	PUZZLE_LAB: "puzzle-lab",
	MORE: "more",
	LOGOUT: "logout",
	BUG: "bug",
	INDEX: "index",
};

export default {
	[ICON_MAP.BELL]: BellIcon,
	[ICON_MAP.BOOK]: BookIcon,
	[ICON_MAP.PROJECTOR]: ProjectorIcon,
	[ICON_MAP.LEADERBOARDS]: LeaderboardsIcon,
	[ICON_MAP.HELP]: HelpIcon,
	[ICON_MAP.SETTINGS]: SettingsIcon,
	[ICON_MAP.HOMEWORK]: HomeworkIcon,
	[ICON_MAP.BEAM]: BeamIcon,
	[ICON_MAP.PUZZLE_LAB]: PuzzleLabIcon,
	[ICON_MAP.MORE]: HamburgerIcon,
	[ICON_MAP.LOGOUT]: LogoutIcon,
	[ICON_MAP.BUG]: BugIcon,
	[ICON_MAP.INDEX]: IndexIcon,
};
